import axios from 'axios';
import { getApiResponse, getRiskApiResponse, getPostResponseAPI } from '../slices/recommendationTableSlice';
import { getGraph, resetNodesAndEdges, setLoaders, setErrorMessage } from '../component/store/access-graph-slice';
import Cookies from 'js-cookie';
let tenantUrl = Cookies.get('tenantUrl');

const handleError = async error => {
  if (error.response) {
    const {
      status
    } = error.response;

    if (status === 400) {
      window.location.replace('/');
    }

    if (status === 403) {
      window.location.replace('/access-denied');
    } // always return the error


    return Promise.reject(error);
  }
};

export const getApiResponseData = (url, type) => dispatch => {
  dispatch(getApiResponse({
    data: {
      isLoading: true
    },
    type
  }));
  return axios.get(tenantUrl + url, {
    withCredentials: true,
    xsrfCookieName: 'csrfToken'
  }).then(data => {
    dispatch(getApiResponse({
      data: { ...data,
        isLoading: false
      },
      type
    }));
  }).catch(error => {
    dispatch(getApiResponse({
      data: {
        isLoading: false
      },
      type
    }));
    handleError(error);
  });
};
export const getRiskAPIResponseData = (url, type) => dispatch => {
  dispatch(getRiskApiResponse({
    data: {
      isLoading: true
    },
    type
  }));
  return axios.get(tenantUrl + url, {
    withCredentials: true,
    xsrfCookieName: 'csrfToken'
  }).then(data => {
    dispatch(getRiskApiResponse({
      data: { ...data,
        isLoading: false
      },
      type
    }));
  }).catch(error => {
    dispatch(getRiskApiResponse({
      data: {
        isLoading: false
      },
      type
    }));
    handleError(error);
  });
};
export const getPostResponseAPIData = (url, type, requestData) => dispatch => {
  dispatch(getPostResponseAPI({
    data: {
      isLoading: true
    },
    type
  }));
  return axios.post(tenantUrl + url, requestData, {
    withCredentials: true,
    xsrfCookieName: 'csrfToken'
  }).then(data => {
    dispatch(getPostResponseAPI({
      data: { ...data,
        isLoading: false
      },
      type
    }));
  }).catch(handleError);
};
export const getgraphData = (url, duration) => dispatch => {
  dispatch(setLoaders(true));
  dispatch(setErrorMessage(''));
  return axios.get(tenantUrl + url + `&accessDuration=${duration}`, {
    withCredentials: true,
    xsrfCookieName: 'csrfToken'
  }).then(response => {
    dispatch(resetNodesAndEdges());

    if (response.data.length) {
      dispatch(getGraph(response.data));
    } else {
      dispatch(setErrorMessage('No Data!!!'));
      dispatch(setLoaders(false));
    }
  }).catch(handleError);
};
export const getFilteredData = (url, filter, duration) => dispatch => {
  dispatch(setLoaders(true));
  dispatch(setErrorMessage(''));
  return axios.get(tenantUrl + url + `&accessType=${filter}&accessDuration=${duration}`, {
    withCredentials: true,
    xsrfCookieName: 'csrfToken'
  }).then(response => {
    dispatch(resetNodesAndEdges());

    if (response.data.length) {
      dispatch(setErrorMessage(''));
      dispatch(getGraph(response.data));
    } else {
      dispatch(setErrorMessage('No Data!!!'));
      dispatch(setLoaders(false));
    }
  }).catch(handleError);
};